<template>
  <div id="app">
    <notifications position="bottom center" width="54%" />
    <div class="row mt-4">
      <h5 class="text-white" id="name">Name and/or Company</h5>
    </div>
    <div class="row mt-1">
      <input
        type="text"
        class="rta-field rta-field-oneline"
        name="name"
        placeholder="Name/Company"
        v-model="name"
      />
    </div>
    <div class="row mt-4">
      <h5 class="text-white" id="name">E-mail</h5>
    </div>
    <div class="row mt-1">
      <input
        type="text"
        class="rta-field rta-field-oneline"
        name="mail"
        placeholder="E-mail"
        v-model="email"
      />
    </div>
    <div class="row mt-4">
      <h5 class="text-white" id="name">Message</h5>
    </div>
    <div class="row mt-1">
      <textarea rows="4" cols="42" class="rta-field" v-model="msg" placeholder="Your message"></textarea>
    </div>
    <div class="row mt-5 mb-1">
      <div style="width: 200px;">
        <button type="button" class="btn btn-highlight btn-lg col-sm" @click="sendMsg">Send</button>
      </div>
    </div>
    <div class="row mt-5">
      <h3 class="text-white">Let's work together!</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data: () => ({
    name: "",
    email: "",
    msg: ""
  }),
  methods: {
    sendMsg() {
      const url =
        "https://firestore.googleapis.com/v1/projects/rta-ctng/databases/(default)/documents/msgs";
      const payload = {
        fields: {
          name: {
            stringValue: this.name
          },
          email: {
            stringValue: this.email
          },
          msg: {
            stringValue: this.msg
          },
          creationDate: {
            timestampValue: new Date()
          }
        }
      };

      if (
        this.name.length > 0 &&
        this.email.length > 0 &&
        this.msg.length > 0
      ) {
        fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8"
          },
          body: JSON.stringify(payload)
        })
          .then(response => {
            if (response.status === 200) {
              this.$notify({
                type: "success",
                title: "Message sent",
                text: "Thanks for your message! We will contact you ASAP."
              });
              this.name = "";
              this.email = "";
              this.msg = "";
            } else {
              this.$notify({
                type: "error",
                title: "An error occured!",
                text: "An error occured, please retry."
              });
            }
          })
          .catch(error => {
            this.$notify({
              type: "error",
              title: "An error occured!",
              text: error
            });
          });
      } else {
        this.$notify({
          type: "error",
          title: "Empty fields",
          text:
            "At least one the fields is empty. Please fill in all the fields!"
        });
      }
    }
  }
};
</script>

<style>
#app {
  font-family: "Sarabun", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
  margin-top: 30px;
}

.notification-title {
  font-family: "Sarabun", sans-serif;
  font-size: 30px;
  font-style: normal;
  font-weight: 900;
  padding-bottom: 8px;
}

.notification-content {
  font-family: "Sarabun", sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.45;
  padding-bottom: 4px;
}
</style>
